import { Container, Stack } from '@mui/material';

import Logo from 'components/Logo';
import ThemeSwitcher from 'layout/common/ThemeSwitcher';

const Header = () => {
  return (
    <Stack direction="row" className="justify-center w-full z-50 bg-primary">
      <Container disableGutters maxWidth="lg">
        <Stack direction="row" className="items-center h-14 sm:h-16 lg:h-20 px-4 md:px-6 sm:mt-8 sm:mx-8 sm:rounded-t-xl border-b bg-paper">
          <Logo />
          <Stack direction="row" spacing={1} className="items-center ml-auto">
            <ThemeSwitcher />
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};

export default Header;
